import { ciEqualsAndHasValue } from 'legacy/lut/helpers/comparison/ciEqualsAndHasValue'

import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs'
import { IPartner } from 'clickNgo/entities/partner/models'

export const checkSamePartner = (original: IPartner, compared: IPartner): boolean => {
  const isHQ = original.hierarchyType === PartnerHierarchyType.HEADQUARTERS
  const isAffiliateOrReseller = [
    PartnerHierarchyType.AFFILIATE,
    PartnerHierarchyType.RESELLER_NETWORK,
  ].includes(original.hierarchyType)

  const isTaxIdSame = ciEqualsAndHasValue(original.taxId, compared.taxId)
  const isCountrySame = original.country && ciEqualsAndHasValue(original.country, compared.country)
  const isCitySame = original.city && ciEqualsAndHasValue(original.city, compared.city)
  const isZIPCodeSame = ciEqualsAndHasValue(original.zipCode, compared.zipCode)
  const isNameSame = ciEqualsAndHasValue(original.communicationName, compared.communicationName)

  if (isCountrySame) {
    if (isHQ) {
      if (isTaxIdSame || (isCitySame && isNameSame)) {
        return true
      }
    } else {
      if (isAffiliateOrReseller) {
        if ((isCitySame || isZIPCodeSame) && (isTaxIdSame || isNameSame)) {
          return true
        }
      } else {
        if ((isCitySame || isZIPCodeSame) && isNameSame) {
          return true
        }
      }
    }
  }

  return false
}
